import { Badge as BadgeA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';

import { resolveClassNames } from '../utils';
import styles from './badge.module.css';

export type BadgeColor = 'caution' | 'error' | 'neutral' | 'success' | 'warning';

// Ant Design `color` and `status` are replaced by BadgeColor. `status="default"` is passed internally so the dot and label stay inline.
export type BadgeProperties = { color?: BadgeColor } & Omit<ComponentProps<typeof BadgeA>, 'color' | 'status'>;

const Badge = ({ children = null, classNames, color, count = null, ...rest }: BadgeProperties) => {
  const isStatusLine = Boolean(color) && count === null && children === null;

  return (
    <BadgeA
      {...rest}
      classNames={resolveClassNames(classNames, (resolvedClassNames) => ({
        ...resolvedClassNames,
        indicator: cn(styles.indicator, resolvedClassNames?.indicator),
        root: cn(
          styles.badge,
          {
            [styles['badge--caution'] ?? '']: color === 'caution',
            [styles['badge--error'] ?? '']: color === 'error',
            [styles['badge--neutral'] ?? '']: color === 'neutral',
            [styles['badge--status'] ?? '']: isStatusLine,
            [styles['badge--success'] ?? '']: color === 'success',
            [styles['badge--warning'] ?? '']: color === 'warning',
          },
          resolvedClassNames?.root,
        ),
      }))}
      count={count}
      status={isStatusLine ? 'default' : undefined}
    >
      {children}
    </BadgeA>
  );
};

export default Badge;
